import { useCallback } from 'react';
import { NotificationTypeV1, } from '@oneaudi/audi-notification-display-service';
import { isBrowser } from './useDesktopOrMobileView';
export const useShareUrl = (notificationDisplayService, successNotificationMessage, successNotificationId = 'copySuccessful') => {
    return useCallback((url) => {
        if (typeof navigator !== 'undefined') {
            if (typeof navigator.share === 'function') {
                navigator.share({ url });
            }
            else {
                copyText(url, notificationDisplayService, successNotificationId, successNotificationMessage);
            }
        }
    }, [notificationDisplayService, successNotificationMessage, successNotificationId]);
};
export function copyText(text, notificationDisplayService, successNotificationId = 'copySuccessful', successNotificationMessage, successNotificationTitle) {
    if (!isBrowser() || typeof navigator === 'undefined' || !text) {
        return;
    }
    navigator.clipboard.writeText(text).then(() => {
        if (notificationDisplayService && successNotificationMessage) {
            if (notificationDisplayService.isOpen(successNotificationId)) {
                notificationDisplayService.closeNotification(successNotificationId);
            }
            notificationDisplayService.createNotification(NotificationTypeV1.POPUP_SUCCESS, successNotificationId, successNotificationMessage || '', { autoCloseAfter: 6, title: successNotificationTitle });
        }
    });
}
